module.exports = __webpack_public_path__ + "img/chijieban6.6e43552e.jpg";